import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAutoApplyFromReviewMutationVariables = Types.Exact<{
    input: Types.UpdateAutoApplyInput;
}>;

export type UpdateAutoApplyFromReviewMutation = {
    __typename?: 'Mutation';
    updateAutoApply: {
        __typename?: 'UpdateAutoApplyPayload';
        autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
        selectedResumeType?: Types.SelectedResumeType | null | undefined;
        sqPastAnswerPrefillPreference?: Types.SqPastAnswerPrefillPreference | null | undefined;
        mode?: Types.AutoApplyMode | null | undefined;
    };
};

export type SetDqPrefillConsentMutationVariables = Types.Exact<{
    consent: Types.Scalars['Boolean']['input'];
}>;

export type SetDqPrefillConsentMutation = {
    __typename?: 'Mutation';
    setDqPrefillConsent?:
        | { __typename: 'SetDqPrefillConsentPayload'; consent: boolean }
        | null
        | undefined;
};

export type DownloadFileResumeForReviewMutationVariables = Types.Exact<{
    fileId: Types.Scalars['ID']['input'];
}>;

export type DownloadFileResumeForReviewMutation = {
    __typename?: 'Mutation';
    createJobSeekerProfileResumeFileTempUrls?:
        | {
              __typename?: 'CreateJobSeekerProfileResumeFileTempUrlsPayload';
              pdfResumeUrl?: any | null | undefined;
          }
        | null
        | undefined;
};

export type AutoApplyDraftsQueryVariables = Types.Exact<{
    first: Types.Scalars['Int']['input'];
}>;

export type AutoApplyDraftsQuery = {
    __typename?: 'Query';
    findReviewBeforeSubmitDrafts?:
        | {
              __typename?: 'FindReviewBeforeSubmitDraftsPayload';
              drafts: Array<{ __typename?: 'AutoApplyDraft'; applicationDraftId: string }>;
          }
        | null
        | undefined;
};

export type GetAutoApplyReviewDataQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAutoApplyReviewDataQuery = {
    __typename?: 'Query';
    jobSeekerProfile?:
        | {
              __typename?: 'JobSeekerProfilePayload';
              profile?:
                  | {
                        __typename?: 'JobSeekerProfile';
                        latestApply?:
                            | {
                                  __typename?: 'JobSeekerProfileLatestApplyPayload';
                                  resumeType?:
                                      | Types.JobSeekerProfileLatestAppliedResumeType
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        defaultInfo?:
                            | {
                                  __typename?: 'JobSeekerProfileDefaultInfo';
                                  contactInformation?:
                                      | {
                                            __typename?: 'JobSeekerProfileContactInformation';
                                            firstName?: string | null | undefined;
                                            lastName?: string | null | undefined;
                                            phoneNumber?: string | null | undefined;
                                            location?:
                                                | {
                                                      __typename?: 'JobSeekerProfileLocationType';
                                                      country?: string | null | undefined;
                                                      formattedLocation?: string | null | undefined;
                                                      city?: string | null | undefined;
                                                      admin1?: string | null | undefined;
                                                      address?: string | null | undefined;
                                                  }
                                                | null
                                                | undefined;
                                        }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        fileInformation: Array<{
                            __typename?: 'JobSeekerProfileFile';
                            id: string;
                            fileName?: string | null | undefined;
                            fileType?: Types.JobSeekerProfileFileType | null | undefined;
                            uploadTimestamp?: any | null | undefined;
                        }>;
                        resume: Array<{
                            __typename?: 'JobSeekerProfileResume';
                            id: string;
                            resumeType?: Types.JobSeekerProfileResumeType | null | undefined;
                            dateModified?: any | null | undefined;
                            firstName?: string | null | undefined;
                            lastName?: string | null | undefined;
                            phoneNumber?: string | null | undefined;
                            headline?: string | null | undefined;
                            summary?: string | null | undefined;
                            location?:
                                | {
                                      __typename?: 'JobSeekerProfileLocationType';
                                      country?: string | null | undefined;
                                      formattedLocation?: string | null | undefined;
                                      city?: string | null | undefined;
                                      admin1?: string | null | undefined;
                                      address?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                            workExperiences: Array<{
                                __typename?: 'JobSeekerProfileWorkExperience';
                                title?: string | null | undefined;
                                company?: string | null | undefined;
                                description?: string | null | undefined;
                                location?:
                                    | {
                                          __typename?: 'JobSeekerProfileLocationType';
                                          formattedLocation?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            educations: Array<{
                                __typename?: 'JobSeekerProfileEducation';
                                school?: string | null | undefined;
                                degree: Array<{
                                    __typename?: 'JobSeekerProfileDegree';
                                    degreeName?: string | null | undefined;
                                    field?: string | null | undefined;
                                }>;
                                location?:
                                    | {
                                          __typename?: 'JobSeekerProfileLocationType';
                                          formattedLocation?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            skills: Array<{
                                __typename?: 'JobSeekerProfileSkill';
                                taxonomyConceptTitle?:
                                    | {
                                          __typename?: 'JobSeekerProfileTaxonomyConcept';
                                          label?: string | null | undefined;
                                          suid?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            certifications: Array<{
                                __typename?: 'JobSeekerProfileCertification';
                                title?: string | null | undefined;
                                description?: string | null | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            languageSkills: Array<{
                                __typename?: 'JobSeekerProfileLanguageSkill';
                                language?: string | null | undefined;
                                proficiency?: string | null | undefined;
                            }>;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              selectedResumeType?: Types.SelectedResumeType | null | undefined;
              autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
              mode?: Types.AutoApplyMode | null | undefined;
              sqPastAnswerPrefillPreference?:
                  | Types.SqPastAnswerPrefillPreference
                  | null
                  | undefined;
          }
        | null
        | undefined;
    currentUser?:
        | {
              __typename?: 'CurrentUserPayload';
              account?:
                  | {
                        __typename?: 'PassportAccount';
                        accountProfile?:
                            | {
                                  __typename?: 'AccountProfile';
                                  email?:
                                      | { __typename?: 'Email'; emailAddress: any }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    jobSeekerProfileDualResumesEnabled?:
        | { __typename?: 'JobSeekerProfileDualResumesEnabledPayload'; enabled: boolean }
        | null
        | undefined;
    jobSeekerResumes?:
        | {
              __typename?: 'JobSeekerResumesPayload';
              resumes: Array<{
                  __typename?: 'JobSeekerResumeBundle';
                  resumeId: string;
                  originalUploadedFile?:
                      | {
                            __typename?: 'JobSeekerResumeFile';
                            metadata: {
                                __typename?: 'JobSeekerProfileFile';
                                id: string;
                                fileName?: string | null | undefined;
                                fileType?: Types.JobSeekerProfileFileType | null | undefined;
                                uploadTimestamp?: any | null | undefined;
                            };
                        }
                      | null
                      | undefined;
                  pdfResumeFile?:
                      | { __typename?: 'JobSeekerResumeFile'; url: string }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export type GetAutoApplyReviewDataWithDqQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAutoApplyReviewDataWithDqQuery = {
    __typename?: 'Query';
    eligiblePastDQAnswers?:
        | { __typename: 'EligiblePastDQAnswersConnection'; consent?: boolean | null | undefined }
        | null
        | undefined;
    jobSeekerProfile?:
        | {
              __typename?: 'JobSeekerProfilePayload';
              profile?:
                  | {
                        __typename?: 'JobSeekerProfile';
                        latestApply?:
                            | {
                                  __typename?: 'JobSeekerProfileLatestApplyPayload';
                                  resumeType?:
                                      | Types.JobSeekerProfileLatestAppliedResumeType
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        defaultInfo?:
                            | {
                                  __typename?: 'JobSeekerProfileDefaultInfo';
                                  contactInformation?:
                                      | {
                                            __typename?: 'JobSeekerProfileContactInformation';
                                            firstName?: string | null | undefined;
                                            lastName?: string | null | undefined;
                                            phoneNumber?: string | null | undefined;
                                            location?:
                                                | {
                                                      __typename?: 'JobSeekerProfileLocationType';
                                                      country?: string | null | undefined;
                                                      formattedLocation?: string | null | undefined;
                                                      city?: string | null | undefined;
                                                      admin1?: string | null | undefined;
                                                      address?: string | null | undefined;
                                                  }
                                                | null
                                                | undefined;
                                        }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        fileInformation: Array<{
                            __typename?: 'JobSeekerProfileFile';
                            id: string;
                            fileName?: string | null | undefined;
                            fileType?: Types.JobSeekerProfileFileType | null | undefined;
                            uploadTimestamp?: any | null | undefined;
                        }>;
                        resume: Array<{
                            __typename?: 'JobSeekerProfileResume';
                            id: string;
                            resumeType?: Types.JobSeekerProfileResumeType | null | undefined;
                            dateModified?: any | null | undefined;
                            firstName?: string | null | undefined;
                            lastName?: string | null | undefined;
                            phoneNumber?: string | null | undefined;
                            headline?: string | null | undefined;
                            summary?: string | null | undefined;
                            location?:
                                | {
                                      __typename?: 'JobSeekerProfileLocationType';
                                      country?: string | null | undefined;
                                      formattedLocation?: string | null | undefined;
                                      city?: string | null | undefined;
                                      admin1?: string | null | undefined;
                                      address?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                            workExperiences: Array<{
                                __typename?: 'JobSeekerProfileWorkExperience';
                                title?: string | null | undefined;
                                company?: string | null | undefined;
                                description?: string | null | undefined;
                                location?:
                                    | {
                                          __typename?: 'JobSeekerProfileLocationType';
                                          formattedLocation?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            educations: Array<{
                                __typename?: 'JobSeekerProfileEducation';
                                school?: string | null | undefined;
                                degree: Array<{
                                    __typename?: 'JobSeekerProfileDegree';
                                    degreeName?: string | null | undefined;
                                    field?: string | null | undefined;
                                }>;
                                location?:
                                    | {
                                          __typename?: 'JobSeekerProfileLocationType';
                                          formattedLocation?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            skills: Array<{
                                __typename?: 'JobSeekerProfileSkill';
                                taxonomyConceptTitle?:
                                    | {
                                          __typename?: 'JobSeekerProfileTaxonomyConcept';
                                          label?: string | null | undefined;
                                          suid?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            certifications: Array<{
                                __typename?: 'JobSeekerProfileCertification';
                                title?: string | null | undefined;
                                description?: string | null | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            languageSkills: Array<{
                                __typename?: 'JobSeekerProfileLanguageSkill';
                                language?: string | null | undefined;
                                proficiency?: string | null | undefined;
                            }>;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              selectedResumeType?: Types.SelectedResumeType | null | undefined;
              autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
              mode?: Types.AutoApplyMode | null | undefined;
              sqPastAnswerPrefillPreference?:
                  | Types.SqPastAnswerPrefillPreference
                  | null
                  | undefined;
          }
        | null
        | undefined;
    currentUser?:
        | {
              __typename?: 'CurrentUserPayload';
              account?:
                  | {
                        __typename?: 'PassportAccount';
                        accountProfile?:
                            | {
                                  __typename?: 'AccountProfile';
                                  email?:
                                      | { __typename?: 'Email'; emailAddress: any }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    jobSeekerProfileDualResumesEnabled?:
        | { __typename?: 'JobSeekerProfileDualResumesEnabledPayload'; enabled: boolean }
        | null
        | undefined;
    jobSeekerResumes?:
        | {
              __typename?: 'JobSeekerResumesPayload';
              resumes: Array<{
                  __typename?: 'JobSeekerResumeBundle';
                  resumeId: string;
                  originalUploadedFile?:
                      | {
                            __typename?: 'JobSeekerResumeFile';
                            metadata: {
                                __typename?: 'JobSeekerProfileFile';
                                id: string;
                                fileName?: string | null | undefined;
                                fileType?: Types.JobSeekerProfileFileType | null | undefined;
                                uploadTimestamp?: any | null | undefined;
                            };
                        }
                      | null
                      | undefined;
                  pdfResumeFile?:
                      | { __typename?: 'JobSeekerResumeFile'; url: string }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export type AutoApplyReviewDataFragment = {
    __typename?: 'Query';
    jobSeekerProfile?:
        | {
              __typename?: 'JobSeekerProfilePayload';
              profile?:
                  | {
                        __typename?: 'JobSeekerProfile';
                        latestApply?:
                            | {
                                  __typename?: 'JobSeekerProfileLatestApplyPayload';
                                  resumeType?:
                                      | Types.JobSeekerProfileLatestAppliedResumeType
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        defaultInfo?:
                            | {
                                  __typename?: 'JobSeekerProfileDefaultInfo';
                                  contactInformation?:
                                      | {
                                            __typename?: 'JobSeekerProfileContactInformation';
                                            firstName?: string | null | undefined;
                                            lastName?: string | null | undefined;
                                            phoneNumber?: string | null | undefined;
                                            location?:
                                                | {
                                                      __typename?: 'JobSeekerProfileLocationType';
                                                      country?: string | null | undefined;
                                                      formattedLocation?: string | null | undefined;
                                                      city?: string | null | undefined;
                                                      admin1?: string | null | undefined;
                                                      address?: string | null | undefined;
                                                  }
                                                | null
                                                | undefined;
                                        }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        fileInformation: Array<{
                            __typename?: 'JobSeekerProfileFile';
                            id: string;
                            fileName?: string | null | undefined;
                            fileType?: Types.JobSeekerProfileFileType | null | undefined;
                            uploadTimestamp?: any | null | undefined;
                        }>;
                        resume: Array<{
                            __typename?: 'JobSeekerProfileResume';
                            id: string;
                            resumeType?: Types.JobSeekerProfileResumeType | null | undefined;
                            dateModified?: any | null | undefined;
                            firstName?: string | null | undefined;
                            lastName?: string | null | undefined;
                            phoneNumber?: string | null | undefined;
                            headline?: string | null | undefined;
                            summary?: string | null | undefined;
                            location?:
                                | {
                                      __typename?: 'JobSeekerProfileLocationType';
                                      country?: string | null | undefined;
                                      formattedLocation?: string | null | undefined;
                                      city?: string | null | undefined;
                                      admin1?: string | null | undefined;
                                      address?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                            workExperiences: Array<{
                                __typename?: 'JobSeekerProfileWorkExperience';
                                title?: string | null | undefined;
                                company?: string | null | undefined;
                                description?: string | null | undefined;
                                location?:
                                    | {
                                          __typename?: 'JobSeekerProfileLocationType';
                                          formattedLocation?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            educations: Array<{
                                __typename?: 'JobSeekerProfileEducation';
                                school?: string | null | undefined;
                                degree: Array<{
                                    __typename?: 'JobSeekerProfileDegree';
                                    degreeName?: string | null | undefined;
                                    field?: string | null | undefined;
                                }>;
                                location?:
                                    | {
                                          __typename?: 'JobSeekerProfileLocationType';
                                          formattedLocation?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            skills: Array<{
                                __typename?: 'JobSeekerProfileSkill';
                                taxonomyConceptTitle?:
                                    | {
                                          __typename?: 'JobSeekerProfileTaxonomyConcept';
                                          label?: string | null | undefined;
                                          suid?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            certifications: Array<{
                                __typename?: 'JobSeekerProfileCertification';
                                title?: string | null | undefined;
                                description?: string | null | undefined;
                                dateRange?:
                                    | {
                                          __typename?: 'JobSeekerProfileDateRange';
                                          isCurrent?: boolean | null | undefined;
                                          fromDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                          toDate?:
                                              | {
                                                    __typename?: 'JobSeekerProfileDateType';
                                                    month?:
                                                        | Types.JobSeekerProfileMonthType
                                                        | null
                                                        | undefined;
                                                    year?: number | null | undefined;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            }>;
                            languageSkills: Array<{
                                __typename?: 'JobSeekerProfileLanguageSkill';
                                language?: string | null | undefined;
                                proficiency?: string | null | undefined;
                            }>;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              selectedResumeType?: Types.SelectedResumeType | null | undefined;
              autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
              mode?: Types.AutoApplyMode | null | undefined;
              sqPastAnswerPrefillPreference?:
                  | Types.SqPastAnswerPrefillPreference
                  | null
                  | undefined;
          }
        | null
        | undefined;
    currentUser?:
        | {
              __typename?: 'CurrentUserPayload';
              account?:
                  | {
                        __typename?: 'PassportAccount';
                        accountProfile?:
                            | {
                                  __typename?: 'AccountProfile';
                                  email?:
                                      | { __typename?: 'Email'; emailAddress: any }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    jobSeekerProfileDualResumesEnabled?:
        | { __typename?: 'JobSeekerProfileDualResumesEnabledPayload'; enabled: boolean }
        | null
        | undefined;
    jobSeekerResumes?:
        | {
              __typename?: 'JobSeekerResumesPayload';
              resumes: Array<{
                  __typename?: 'JobSeekerResumeBundle';
                  resumeId: string;
                  originalUploadedFile?:
                      | {
                            __typename?: 'JobSeekerResumeFile';
                            metadata: {
                                __typename?: 'JobSeekerProfileFile';
                                id: string;
                                fileName?: string | null | undefined;
                                fileType?: Types.JobSeekerProfileFileType | null | undefined;
                                uploadTimestamp?: any | null | undefined;
                            };
                        }
                      | null
                      | undefined;
                  pdfResumeFile?:
                      | { __typename?: 'JobSeekerResumeFile'; url: string }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export const AutoApplyReviewDataFragmentDoc = gql`
    fragment AutoApplyReviewData on Query {
        jobSeekerProfile {
            profile {
                latestApply {
                    resumeType
                }
                defaultInfo {
                    contactInformation {
                        firstName
                        lastName
                        phoneNumber
                        location {
                            country
                            formattedLocation
                            city
                            admin1
                            address
                        }
                    }
                }
                fileInformation {
                    id
                    fileName
                    fileType
                    uploadTimestamp
                }
                resume {
                    id
                    resumeType
                    dateModified
                    firstName
                    lastName
                    phoneNumber
                    headline
                    summary
                    location {
                        country
                        formattedLocation
                        city
                        admin1
                        address
                    }
                    workExperiences {
                        title
                        company
                        description
                        location {
                            formattedLocation
                        }
                        dateRange {
                            fromDate {
                                month
                                year
                            }
                            toDate {
                                month
                                year
                            }
                            isCurrent
                        }
                    }
                    educations {
                        degree {
                            degreeName
                            field
                        }
                        school
                        location {
                            formattedLocation
                        }
                        dateRange {
                            fromDate {
                                month
                                year
                            }
                            toDate {
                                month
                                year
                            }
                            isCurrent
                        }
                    }
                    skills {
                        taxonomyConceptTitle {
                            label
                            suid
                        }
                    }
                    certifications {
                        title
                        description
                        dateRange {
                            fromDate {
                                month
                                year
                            }
                            toDate {
                                month
                                year
                            }
                            isCurrent
                        }
                    }
                    languageSkills {
                        language
                        proficiency
                    }
                }
            }
        }
        autoApplyInfo {
            selectedResumeType
            autoApplyStatus
            mode
            sqPastAnswerPrefillPreference
        }
        currentUser {
            account {
                ... on PassportAccount {
                    accountProfile {
                        email {
                            emailAddress
                        }
                    }
                }
            }
        }
        jobSeekerProfileDualResumesEnabled {
            enabled
        }
        jobSeekerResumes {
            resumes {
                resumeId
                originalUploadedFile {
                    metadata {
                        id
                        fileName
                        fileType
                        uploadTimestamp
                    }
                }
                pdfResumeFile {
                    url
                }
            }
        }
    }
`;
export const UpdateAutoApplyFromReviewDocument = gql`
    mutation UpdateAutoApplyFromReview($input: UpdateAutoApplyInput!) {
        updateAutoApply(input: $input) {
            autoApplyStatus
            selectedResumeType
            sqPastAnswerPrefillPreference
            mode
        }
    }
`;
export type UpdateAutoApplyFromReviewMutationFn = Apollo.MutationFunction<
    UpdateAutoApplyFromReviewMutation,
    UpdateAutoApplyFromReviewMutationVariables
>;

/**
 * __useUpdateAutoApplyFromReviewMutation__
 *
 * To run a mutation, you first call `useUpdateAutoApplyFromReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoApplyFromReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoApplyFromReviewMutation, { data, loading, error }] = useUpdateAutoApplyFromReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutoApplyFromReviewMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateAutoApplyFromReviewMutation,
        UpdateAutoApplyFromReviewMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateAutoApplyFromReviewMutation,
        UpdateAutoApplyFromReviewMutationVariables
    >(UpdateAutoApplyFromReviewDocument, options);
}
export type UpdateAutoApplyFromReviewMutationHookResult = ReturnType<
    typeof useUpdateAutoApplyFromReviewMutation
>;
export type UpdateAutoApplyFromReviewMutationResult =
    Apollo.MutationResult<UpdateAutoApplyFromReviewMutation>;
export type UpdateAutoApplyFromReviewMutationOptions = Apollo.BaseMutationOptions<
    UpdateAutoApplyFromReviewMutation,
    UpdateAutoApplyFromReviewMutationVariables
>;
export const SetDqPrefillConsentDocument = gql`
    mutation SetDqPrefillConsent($consent: Boolean!) {
        setDqPrefillConsent(input: { consent: $consent }) {
            __typename
            consent
        }
    }
`;
export type SetDqPrefillConsentMutationFn = Apollo.MutationFunction<
    SetDqPrefillConsentMutation,
    SetDqPrefillConsentMutationVariables
>;

/**
 * __useSetDqPrefillConsentMutation__
 *
 * To run a mutation, you first call `useSetDqPrefillConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDqPrefillConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDqPrefillConsentMutation, { data, loading, error }] = useSetDqPrefillConsentMutation({
 *   variables: {
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useSetDqPrefillConsentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SetDqPrefillConsentMutation,
        SetDqPrefillConsentMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<SetDqPrefillConsentMutation, SetDqPrefillConsentMutationVariables>(
        SetDqPrefillConsentDocument,
        options,
    );
}
export type SetDqPrefillConsentMutationHookResult = ReturnType<
    typeof useSetDqPrefillConsentMutation
>;
export type SetDqPrefillConsentMutationResult = Apollo.MutationResult<SetDqPrefillConsentMutation>;
export type SetDqPrefillConsentMutationOptions = Apollo.BaseMutationOptions<
    SetDqPrefillConsentMutation,
    SetDqPrefillConsentMutationVariables
>;
export const DownloadFileResumeForReviewDocument = gql`
    mutation DownloadFileResumeForReview($fileId: ID!) {
        createJobSeekerProfileResumeFileTempUrls(input: { id: $fileId }) {
            pdfResumeUrl
        }
    }
`;
export type DownloadFileResumeForReviewMutationFn = Apollo.MutationFunction<
    DownloadFileResumeForReviewMutation,
    DownloadFileResumeForReviewMutationVariables
>;

/**
 * __useDownloadFileResumeForReviewMutation__
 *
 * To run a mutation, you first call `useDownloadFileResumeForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileResumeForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFileResumeForReviewMutation, { data, loading, error }] = useDownloadFileResumeForReviewMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDownloadFileResumeForReviewMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DownloadFileResumeForReviewMutation,
        DownloadFileResumeForReviewMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        DownloadFileResumeForReviewMutation,
        DownloadFileResumeForReviewMutationVariables
    >(DownloadFileResumeForReviewDocument, options);
}
export type DownloadFileResumeForReviewMutationHookResult = ReturnType<
    typeof useDownloadFileResumeForReviewMutation
>;
export type DownloadFileResumeForReviewMutationResult =
    Apollo.MutationResult<DownloadFileResumeForReviewMutation>;
export type DownloadFileResumeForReviewMutationOptions = Apollo.BaseMutationOptions<
    DownloadFileResumeForReviewMutation,
    DownloadFileResumeForReviewMutationVariables
>;
export const AutoApplyDraftsDocument = gql`
    query AutoApplyDrafts($first: Int!) {
        findReviewBeforeSubmitDrafts(input: { first: $first }) {
            drafts {
                applicationDraftId
            }
        }
    }
`;

/**
 * __useAutoApplyDraftsQuery__
 *
 * To run a query within a React component, call `useAutoApplyDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoApplyDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoApplyDraftsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAutoApplyDraftsQuery(
    baseOptions: Apollo.QueryHookOptions<AutoApplyDraftsQuery, AutoApplyDraftsQueryVariables> &
        ({ variables: AutoApplyDraftsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<AutoApplyDraftsQuery, AutoApplyDraftsQueryVariables>(
        AutoApplyDraftsDocument,
        options,
    );
}
export function useAutoApplyDraftsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<AutoApplyDraftsQuery, AutoApplyDraftsQueryVariables>,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<AutoApplyDraftsQuery, AutoApplyDraftsQueryVariables>(
        AutoApplyDraftsDocument,
        options,
    );
}
export function useAutoApplyDraftsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<AutoApplyDraftsQuery, AutoApplyDraftsQueryVariables>,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<AutoApplyDraftsQuery, AutoApplyDraftsQueryVariables>(
        AutoApplyDraftsDocument,
        options,
    );
}
export type AutoApplyDraftsQueryHookResult = ReturnType<typeof useAutoApplyDraftsQuery>;
export type AutoApplyDraftsLazyQueryHookResult = ReturnType<typeof useAutoApplyDraftsLazyQuery>;
export type AutoApplyDraftsSuspenseQueryHookResult = ReturnType<
    typeof useAutoApplyDraftsSuspenseQuery
>;
export type AutoApplyDraftsQueryResult = Apollo.QueryResult<
    AutoApplyDraftsQuery,
    AutoApplyDraftsQueryVariables
>;
export const GetAutoApplyReviewDataDocument = gql`
    query GetAutoApplyReviewData {
        ...AutoApplyReviewData
    }
    ${AutoApplyReviewDataFragmentDoc}
`;

/**
 * __useGetAutoApplyReviewDataQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyReviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyReviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyReviewDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoApplyReviewDataQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAutoApplyReviewDataQuery,
        GetAutoApplyReviewDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAutoApplyReviewDataQuery, GetAutoApplyReviewDataQueryVariables>(
        GetAutoApplyReviewDataDocument,
        options,
    );
}
export function useGetAutoApplyReviewDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyReviewDataQuery,
        GetAutoApplyReviewDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAutoApplyReviewDataQuery, GetAutoApplyReviewDataQueryVariables>(
        GetAutoApplyReviewDataDocument,
        options,
    );
}
export function useGetAutoApplyReviewDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplyReviewDataQuery,
              GetAutoApplyReviewDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAutoApplyReviewDataQuery,
        GetAutoApplyReviewDataQueryVariables
    >(GetAutoApplyReviewDataDocument, options);
}
export type GetAutoApplyReviewDataQueryHookResult = ReturnType<
    typeof useGetAutoApplyReviewDataQuery
>;
export type GetAutoApplyReviewDataLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplyReviewDataLazyQuery
>;
export type GetAutoApplyReviewDataSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyReviewDataSuspenseQuery
>;
export type GetAutoApplyReviewDataQueryResult = Apollo.QueryResult<
    GetAutoApplyReviewDataQuery,
    GetAutoApplyReviewDataQueryVariables
>;
export const GetAutoApplyReviewDataWithDqDocument = gql`
    query GetAutoApplyReviewDataWithDq {
        ...AutoApplyReviewData
        eligiblePastDQAnswers {
            __typename
            consent
        }
    }
    ${AutoApplyReviewDataFragmentDoc}
`;

/**
 * __useGetAutoApplyReviewDataWithDqQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyReviewDataWithDqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyReviewDataWithDqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyReviewDataWithDqQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoApplyReviewDataWithDqQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAutoApplyReviewDataWithDqQuery,
        GetAutoApplyReviewDataWithDqQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAutoApplyReviewDataWithDqQuery,
        GetAutoApplyReviewDataWithDqQueryVariables
    >(GetAutoApplyReviewDataWithDqDocument, options);
}
export function useGetAutoApplyReviewDataWithDqLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyReviewDataWithDqQuery,
        GetAutoApplyReviewDataWithDqQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAutoApplyReviewDataWithDqQuery,
        GetAutoApplyReviewDataWithDqQueryVariables
    >(GetAutoApplyReviewDataWithDqDocument, options);
}
export function useGetAutoApplyReviewDataWithDqSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplyReviewDataWithDqQuery,
              GetAutoApplyReviewDataWithDqQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAutoApplyReviewDataWithDqQuery,
        GetAutoApplyReviewDataWithDqQueryVariables
    >(GetAutoApplyReviewDataWithDqDocument, options);
}
export type GetAutoApplyReviewDataWithDqQueryHookResult = ReturnType<
    typeof useGetAutoApplyReviewDataWithDqQuery
>;
export type GetAutoApplyReviewDataWithDqLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplyReviewDataWithDqLazyQuery
>;
export type GetAutoApplyReviewDataWithDqSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyReviewDataWithDqSuspenseQuery
>;
export type GetAutoApplyReviewDataWithDqQueryResult = Apollo.QueryResult<
    GetAutoApplyReviewDataWithDqQuery,
    GetAutoApplyReviewDataWithDqQueryVariables
>;
